import React from 'react';
import { getPopupFeatures } from './utils';
export const useModalystInstall = _ref => {
  let {
    onSuccess,
    // onCancel,
    referral,
    usePopup = true,
    modalystOrigin = 'https://modalyst.co'
  } = _ref;
  const messageListenerRef = React.useRef();
  const removeMessageListener = () => {
    if (messageListenerRef.current) {
      window.removeEventListener('message', messageListenerRef.current);
    }
  };
  const startInstall = params => {
    removeMessageListener();
    const paramsStr = new URLSearchParams({
      ...params,
      referral
    }).toString();
    const url = `${modalystOrigin}/store-auth/wix-install/?${paramsStr}`;
    const opened = usePopup ? window.open(url, 'popupWindow', getPopupFeatures()) : window.open(url, '_blank');
    messageListenerRef.current = event => {
      const {
        origin,
        data
      } = event;
      const {
        token,
        status
      } = data;
      if (origin !== modalystOrigin || token !== params.modalystToken) {
        return;
      }
      if (status === 'OK') {
        if (usePopup) {
          opened == null || opened.close();
        }
        removeMessageListener();
        onSuccess == null || onSuccess();
      }
    };
    window.addEventListener('message', messageListenerRef.current, false);
  };
  React.useEffect(() => removeMessageListener, []);
  return {
    removeMessageListener,
    messageListenerRef,
    startInstall
  };
};
//# sourceMappingURL=hooks.js.map